document.addEventListener("DOMContentLoaded", () => {
  // Get all FAQ buttons
  const items = document.querySelectorAll(".faq button");
  
  if (!items || items.length === 0) {
    console.warn('No FAQ buttons found on page');
    return;
  }

  // Set initial state for all buttons
  items.forEach(button => {
    button.setAttribute("aria-expanded", "false");
  });

  function toggleFaq(event) {
    if (!event || !event.currentTarget) {
      console.error('Invalid event object');
      return;
    }

    const button = event.currentTarget;
    const isExpanded = button.getAttribute("aria-expanded") === "true";

    try {
      // Toggle only the clicked item
      button.setAttribute("aria-expanded", !isExpanded);
      
      // Handle panel visibility
      const panel = button.nextElementSibling;
      if (panel) {
        if (!isExpanded) {
          panel.style.display = "block";
          panel.style.maxHeight = panel.scrollHeight + "px";
        } else {
          panel.style.maxHeight = null;
          panel.style.display = "none";
        }
      }
    } catch (error) {
      console.error('Error toggling FAQ:', error);
    }
  }

  // Add click handlers
  items.forEach((item) => {
    if (item) {
      item.addEventListener("click", toggleFaq);
    }
  });
});
